import React, { Component, Fragment } from "react";
import DeleteModel from "./DeleteModel";
import AppContext from "../../../contexts/AppContext";

class PaymentMethodList extends Component {
    state = {
        delete: false,
        update: false,
        item: {}
    };

    /* delete */
    delete = () => {
        return this.props.delete(this.props.item.id);
    };
    toggleDelete = () => {
        this.setState({ delete: this.state.delete === true ? false : true });
    };

    /* update */
    toggleUpdate = () => {
        this.state.update === true
            ? this.setState({ update: false })
            : this.props
                  .getItem(this.props.item.id)
                  .then(response => {
                      this.setState({ update: true, item: response.data });
                  })
                  .catch(error => {
                      this.context.state.handelError(error);
                  });
    };

    render() {
        return (
            <Fragment>
                <tr>
                    <td>{this.props.item.id}</td>
                    <td>
                        <div className="row align-items-center">
                            <div className="col-auto">
                                <a href="">
                                    <img
                                        src={`/cards/${this.props.item.type}.png`}
                                        className="cc-image-lg"
                                        alt=""
                                    ></img>
                                </a>
                            </div>
                            <div className="col ml-n2">
                                <h4 className="mb-1 name">
                                    •••• •••• •••• {this.props.item.code}
                                </h4>
                                <p className="small mb-0">
                                    last update {this.props.item.updated_at}
                                </p>
                            </div>
                        </div>
                    </td>
                    <td>
                        <time dateTime={this.props.item.created_at}>
                            {this.props.item.created_at}
                        </time>
                    </td>

                    <td className="text-right">
                        <button
                            onClick={this.toggleDelete}
                            type="button"
                            className="btn btn-danger btn-sm ml-2"
                        >
                            Delete
                        </button>
                    </td>
                </tr>
                {this.state.delete === true ? (
                    <DeleteModel
                        delete={this.delete}
                        hideDelete={this.toggleDelete}
                    ></DeleteModel>
                ) : null}
            </Fragment>
        );
    }
}
PaymentMethodList.contextType = AppContext;
export default PaymentMethodList;



// WEBPACK FOOTER //
// ./src/components/employer/billing/PaymentMethodList.js